// extracted by mini-css-extract-plugin
export default {"Outer":"Checkbox_Outer__zXJPX","Checked":"Checkbox_Checked__5veAO"};